import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    ADJUSTMENTS_FAILURE,
    ADJUSTMENTS_LOAD,
    ADJUSTMENTS_SUCCESS
} from './adjustmentsActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let  newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                adjustments: []
            };

            return isEqual(state, newState) ? state : newState;

        case ADJUSTMENTS_LOAD:
            newState = {
                ...state,
                adjustments: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case ADJUSTMENTS_SUCCESS:
            newState = {
                ...state,
                adjustments: action.adjustments,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case ADJUSTMENTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getAdjustmentsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'adjustments')
);

export const getPages = createSelector(
    getAdjustmentsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getAdjustmentsEntity,
    (entity) => get(entity, 'count')
);

export const getIsAdjustmentsLoading = createSelector(
    getAdjustmentsEntity,
    (entity) => get(entity, 'loading')
);

export const getAdjustments = createSelector(
    getAdjustmentsEntity,
    (entity) => get(entity, 'adjustments')
);

export const getAdjustmentsError = createSelector(
    getAdjustmentsEntity,
    (entity) => get(entity, 'error')
);

export const getAdjustmentsErrorMessage = createSelector(
    getAdjustmentsError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getAdjustmentsEntity,
    (entity) => get(entity, 'hasMore')
);
